import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { style, themeGet } from 'styled-system';
import { Text, NakedButton } from 'roo-ui/components';

const textDecoration = style({
  prop: 'textDecoration',
  cssProperty: 'textDecoration',
});

const hoverColor = style({
  prop: 'hoverColor',
  cssProperty: 'color',
  key: 'colors',
});

const ColoredText = styled(Text)`
  ${textDecoration}
  ${NakedButton}:hover & {
    ${hoverColor}
  }

  ${NakedButton}:disabled & {
    color: ${themeGet('colors.greys.steel')};
  }
`;

NakedButton.displayName = 'NakedButton';
ColoredText.displayName = 'ColoredText';

const TextButton = ({ children, onClick, disabled, ...props }) => {
  return (
    <NakedButton onClick={onClick} disabled={disabled}>
      <ColoredText {...props} display="inline-block">
        {children}
      </ColoredText>
    </NakedButton>
  );
};

TextButton.propTypes = {
  children: PropTypes.node,
  onClick: PropTypes.func.isRequired,
  hoverColor: PropTypes.string,
  color: PropTypes.string,
  textDecoration: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  disabled: PropTypes.bool,
};

TextButton.defaultProps = {
  hoverColor: 'maroon',
  textDecoration: 'underline',
  color: 'brand.primary',
  disabled: false,
  children: null,
};

export default TextButton;
